import loaderClient, { clientNoLoader } from "api/reduxLoaderApi";
import { toast } from "react-toastify";
import {
  setDefaultGroups,
  setFleets,
  setGroupPolicies,
  setGroups,
  updateGroups,
  updateAirlinePermissionGroups,
  setRoleAndPermissions,
  setAirlinePermissionGroups,
} from "./groupsSlice";
import { selAirlineId } from "store/slices";
/* -------------------------------------------------------------------------- */
export const getRoleAndPermissions =
  (callback) => async (dispatch, getState) => {
    const airlineId = selAirlineId(getState());
    const client = loaderClient("get")(`/v2/role-and-permissions/dictionaries`);
    const res = await client({})({});
    if (!res.error) dispatch(setRoleAndPermissions(res.message));
    callback && callback(res.error, res.message);
  };
/* -------------------------------------------------------------------------- */
export const getAirlinePermissionGroups =
  (callback = false) =>
  async (dispatch, getState) => {
    //const airlineId = selAirlineId(getState());
    const client = loaderClient("get")(
      `/v2/airline-permission-groups?limit=all`
    );
    const res = await client({})({});
    if (!res.error) dispatch(setAirlinePermissionGroups(res.message));
    callback && callback(res.error, res.message);
  };
/* -------------------------------------------------------------------------- */
export const getDefaultGroups = () => async (dispatch, getState) => {
  const airlineId = selAirlineId(getState());
  const client = loaderClient("get")(
    `/permissions/policy-permissions?airline=${airlineId}&limit=all`
  );
  const res = await client({})({});
  if (res.error) return;
  return dispatch(setDefaultGroups(res.message));
};
/* -------------------------------------------------------------------------- */
export const getGroupPolicies = () => async (dispatch, getState) => {
  const airlineId = selAirlineId(getState());
  const client = loaderClient("get")(
    `/groups/group-policy/policies?airline=${airlineId}&limit=all`
  );
  const res = await client({})({});
  if (res.error) return;
  return dispatch(setGroupPolicies(res.message));
};
/* -------------------------------------------------------------------------- */
export const getGroups = () => async (dispatch, getState) => {
  const airlineId = selAirlineId(getState());
  const client = loaderClient("get")(`/groups/?airline=${airlineId}&limit=all`);
  const res = await client({})({});
  if (res.error) return;
  return dispatch(setGroups(res.message));
};
/* -------------------------------------------------------------------------- */
export const updateGroup =
  (groupId, body, callback) => async (dispatch, getState) => {
    const airlineId = selAirlineId(getState());
    const client = loaderClient("patch")(
      `/v2/airline-permission-groups/${groupId}`
    );
    const res = await client({ ...body })({});
    if (!res.error) {
      toast.success("Group Updated Successfully");
      dispatch(updateAirlinePermissionGroups({ groupId, fields: res.message }));
    } else {
      toast.error(res.message || "Error in updating Group");
    }
    return callback && callback(res.error, res.message);
  };
/* -------------------------------------------------------------------------- */
export const createGroup = (body, callback) => async (dispatch, getState) => {
  const airlineId = selAirlineId(getState());
  const client = loaderClient("post")(`/v2/airline-permission-groups`);
  const res = await client({ ...body })({});
  if (!res.error) {
    toast.success("Group Created Successfully");
    dispatch(getAirlinePermissionGroups());
  } else {
    toast.error(res.message || "Error in creating Group");
  }
  return callback && callback(res.error, res.message);
};
/* -------------------------------------------------------------------------- */
export const deleteGroup = (groupId, callback) => async (dispatch) => {
  const client = loaderClient("delete")(`/groups/${groupId}`);
  const res = await client({})({});
  if (res.error) return;
  toast.success("Group Deleted");
  dispatch(getGroups());
  return callback && callback();
};
/* -------------------------------------------------------------------------- */
export const updateGroupUsers =
  (groupId, body, callback) => async (dispatch) => {
    const client = clientNoLoader("patch")(
      `/v2/airline-permission-groups/${groupId}/users`
    );
    const res = await client({ ...body })({});
    if (!res.error) {
      dispatch(
        updateAirlinePermissionGroups({
          groupId,
          fields: { users: res.message },
        })
      );
    }
    return callback?.(res.error, res.message);
  };
/* -------------------------------------------------------------------------- */
export const getFleets = () => async (dispatch, getState) => {
  const airlineId = selAirlineId(getState());
  const client = loaderClient("get")(`/fleets?airline=${airlineId}&limit=all`);
  const res = await client({})({});
  if (res.error) return;
  return dispatch(setFleets(res.message));
};
